import React, {useState} from 'react';
import {InfoOutlined} from "@mui/icons-material";
import {ClickAwayListener, Paper, Popper} from "@mui/material";
import "components/UI/Popper/InfoPopper.css"

const InfoPopper = (props) => {

    const {message, size} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [isPopperOpen, setIsPopperOpen] = useState(false);

    const clickAwayHandler = () => setIsPopperOpen(false);

    const togglePopper = (event) => {
        setAnchorEl(event.currentTarget);
        isPopperOpen ? setIsPopperOpen(false) : setIsPopperOpen(true);
    }

    return (
        <div>
            <ClickAwayListener onClickAway={clickAwayHandler}>
                <div>
                    <InfoOutlined onClick={togglePopper} fontSize={size} sx={{opacity: '.5'}}/>
                    <Popper open={isPopperOpen} anchorEl={anchorEl} placement={'right-start'}>
                        <Paper className="paper" elevation={3} square={false}>
                            {message}
                        </Paper>
                    </Popper>
                </div>
            </ClickAwayListener>
        </div>
    );
};

export default InfoPopper;
